export default {
	path: '/speaker',
	redirect: '/speaker',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'speakerHome',
			component: () => import('@/views/mng/Speaker'),
		},
	],
};
